/**
 * Service templates whose usage is reconciled monthly ("đối soát" / statement
 * billing) — the ONLY templates where a per-config `statementable` flag has any
 * billing effect. Sourced verbatim from the Go backend's hardcoded
 * `StatementableTemplates` (datacentral-api-v4 `pkg/billing/types.go`;
 * `IsStatementable()` gates `DynamicCalculator.calculateStatement()`).
 *
 * Outside this set the flag is IGNORED at billing time, so the contract-create
 * UI must NOT render a Statement toggle for those templates — showing it is a
 * false affordance (user ticks it expecting reconciliation that never happens).
 * For templates in this set the flag defaults to TRUE (analytics treats
 * unset/null as true: `COALESCE(sco.statementable, TRUE)`).
 */
export const STATEMENTABLE_TEMPLATES = new Set<string>([
  'SwiftFederation.CDN',
  'SwiftFederation.Transcoding',
  'SwiftFederation.Transmuxing',
  'SwiftFederation.Recording',
  'SwiftFederation.StorageLFD',
  'SwiftFederation.StorageOSS',
  'Mlytics.Vnis',
]);

/** True when the product's template participates in usage reconciliation. */
export function isStatementable(templateName?: string): boolean {
  return !!templateName && STATEMENTABLE_TEMPLATES.has(templateName);
}
